import type { UseMutationResult } from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'

import { updateProductionPlanObligationPeriod } from '@/features/portfolioHierarchy/endpoints/productionPlanObligationPeriods'
import type {
  EditProductionPlanObligationFormData,
  ProductionPlanObligationPeriod,
} from '@/features/portfolioHierarchy/types'
import type { UseMutationOptions } from '@/types/queries'

export type UseUpdateProductionPlanObligationPeriodMutationResult = Omit<
  UseMutationResult<ProductionPlanObligationPeriod, Error, EditProductionPlanObligationFormData>,
  'mutateAsync'
> & {
  updateObligationPeriod: UseMutationResult<
    ProductionPlanObligationPeriod,
    Error,
    EditProductionPlanObligationFormData
  >['mutateAsync']
}

export function useUpdateProductionPlanObligationPeriodMutation(
  options?: UseMutationOptions<ProductionPlanObligationPeriod, EditProductionPlanObligationFormData>,
): UseUpdateProductionPlanObligationPeriodMutationResult {
  const { mutateAsync, ...mutationResult } = useMutation({
    ...options,
    mutationFn: (variables: EditProductionPlanObligationFormData) => updateProductionPlanObligationPeriod(variables),
  })

  return { updateObligationPeriod: mutateAsync, ...mutationResult }
}
